module.exports = __webpack_public_path__ + "static/reactNativeLove-e52f6ecd43a88a65fa1488dfc9a4e795.png";